export default "__VITE_ASSET__Cp86AINp__"